import { Fragment, memo, ReactElement } from 'react';
import { Form, Formik } from 'formik';
import { ResearchAct } from 'civil-status/view-models/research-category-form';
import { ResearchNotifications } from 'civil-status/view-models/notifications-list';
import AccordionFilterPerson, {
  validationSchemaResearchPerson,
} from 'civil-status/components/shared/filter-person';

interface AccordionFilterNotificationsPersonProps {
  open?: boolean;
  setOpen: (value: boolean) => void;
  handleSubmitResearchPerson: (values: ResearchAct) => void;
  initialValues?: ResearchAct;
}

const AccordionFilterNotificationsPersonComponent = ({
  open,
  setOpen,
  handleSubmitResearchPerson,
  initialValues,
}: AccordionFilterNotificationsPersonProps): ReactElement => {
  return (
    <Fragment>
      <Formik
        initialValues={
          initialValues ||
          ({
            birthDate: undefined,
            fiscalCode: undefined,
            name: undefined,
            surname: undefined,
            idAnpr: undefined,
            idAnsc: undefined,
            isForeign: false,
            municipality: undefined,
            state: undefined,
            gender: undefined,
          } as ResearchNotifications)
        }
        onSubmit={handleSubmitResearchPerson}
        validateOnMount
        validationSchema={validationSchemaResearchPerson}
      >
        <Form>
          <AccordionFilterPerson open={open} setOpen={setOpen} />
        </Form>
      </Formik>
    </Fragment>
  );
};

AccordionFilterNotificationsPersonComponent.displayName =
  'Research notifications - Filters component - AccordionFilterNotificationsPerson';

const AccordionFilterNotificationsPerson = memo(AccordionFilterNotificationsPersonComponent);

export default AccordionFilterNotificationsPerson;
